import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DataGrid,
  Grid,
  Input,
} from '../../../components';
import {
  tipoEntidade,
  tipoRegime as listaTipoRegime,
} from '../../../utils/listsSelect';
import {
  buscaDestinatarios,
} from '../../../utils/requests';

const destinoRGPS = '01000';

class SelecaoDestinatario extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    tipoRegime: null,
    tipoEntidade: null,
    uf: null,
    destinatario: null,
    destinatarioOrigem: null,
  });

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  // Encaminha para as funcoes que tratam alteracoes em cada campo
  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoRegime') {
      this.trataTipoRegime();
      this.props.apagaRegraDeCalculo();
    }
    if (campoAlterado === 'tipoEntidade') {
      this.trataTipoEntidade();
    }
    if (campoAlterado === 'uf') {
      this.trataUf();
    }
    if (campoAlterado === 'destinatario') {
      this.trataDestinatario();
    }
  }

  trataUf = () => {
    this.setState(
      {
        destinatario: null,
      },
      () => {
        this.props.handleChange({
          value: null,
          isValid: false,
        }, 'destinatario');
      },
    );
  }

  trataDestinatario = () => {
    this.props.handleChange({
      value: this.state.destinatario,
      isValid: true,
    }, 'destinatario');
    this.props.calcularTempoRO(this.state.destinatario, false);
  }

  trataDestinatarioOrigem = (orgaoCentralizador) => {
    this.props.handleChange({
      value: orgaoCentralizador,
      isValid: true,
    }, 'destinatarioOrigem');
  }

  trataTipoEntidade = () => {
    this.setState(
      {
        destinatario: null,
        uf: null,
      },
      () => {
        this.props.handleChange({
          value: null,
          isValid: false,
        }, 'destinatario');
      },
    );
  }

  trataTipoRegime = () => {
    const tipoEntidadeAposAlteracao = null;
    let destinatarioAposAlteracao = null;
    if (this.state.tipoRegime === 1) {
      destinatarioAposAlteracao = destinoRGPS;
    }
    this.setState(
      {
        tipoEntidade: tipoEntidadeAposAlteracao,
        destinatario: destinatarioAposAlteracao,
      },
      () => {
        this.props.handleChange({
          value: destinatarioAposAlteracao,
          isValid: destinatarioAposAlteracao !== null,
        }, 'destinatario');
      }, this.props.calcularTempoRO(destinatarioAposAlteracao, false),
    );
  }

  // Campos podem ser alterados apenas quando requerimento for novo
  verificaCampoBloqueado = () => {
    if (this.props.acao === 'novo') {
      return false;
    }
    return true;
  }

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  buscaDestinatarios = () => {
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.buscaDestinatariosFail);
    }
  }

  buscaDestinatariosFail = () => {
    this.setState({ tipoRegime: null });
  }

  /**
   * Tipo de entidade deve ser carregado dinamicamente se:
   * - Destinatario estiver escolhido;
   * - For diferente de RGPS;
   * - Tipo de entidade estiver em branco
   */
  montaValorTipoEntidade = () => {
    if (this.state.destinatario &&
      this.state.destinatario !== destinoRGPS && !this.state.tipoEntidade) {
      const objDestinatario =
      this.props.destinatarios.find(dest => dest.value === this.state.destinatario);
      return objDestinatario.tipoRegimeProprio;
    }
    return this.state.tipoEntidade;
  }

  render() {
    let listaTipoRegimes = listaTipoRegime;
    if (this.props.acao !== 'novo') {
      return null;
    }
    let selecaoDestinacao;
    let labelAviso;
    if (this.state.tipoRegime === 2) {
      this.buscaDestinatarios();
      selecaoDestinacao = (
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={this.verificaCampoBloqueado()}
              label="Entidade"
              onChange={e => this.handleChange(e, 'tipoEntidade')}
              placeholder="Selecione a entidade"
              value={this.montaValorTipoEntidade()}
              itemList={tipoEntidade}
              custom
              number
            />
          </Grid>
          {this.state.tipoEntidade === 2 ? (
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.verificaCampoBloqueado()}
                label="UF"
                onChange={e => this.handleChange(e, 'uf')}
                placeholder="Selecione a UF"
                value={this.state.uf}
                itemList={this.carregaUfDosMunicipios()}
                custom
              />
            </Grid>
          ) : ''}
          <Grid cols="8 8 8 8">
            <Input
              disabled={this.verificaCampoBloqueado()}
              label="Destinatário"
              onChange={e => this.handleChange(e, 'destinatario')}
              placeholder="Selecione o destinatário"
              value={this.state.destinatario}
              itemList={this.listaFiltradaDestinatarios()}
              custom
            />
          </Grid>
        </div>
      );
    }
    if (this.props.isRgpsSelecionando) {
      listaTipoRegimes = listaTipoRegimes.filter(item => (item.label !== 'RGPS'));
    }

    if (this.state.tipoEntidade === 1 && this.state.destinatario) {
      let orgaoCentralizador = '';

      const orgao =
      this.props.destinatarios.find(itemLista => itemLista.value === this.state.destinatario);

      if (orgao.codigoOrgaoCentralizador) {
        orgaoCentralizador =
        this.props.destinatarios.find(item => item.value === orgao.codigoOrgaoCentralizador);

        labelAviso = `Este requerimento será destinado a ${orgaoCentralizador.label}
        que ${orgao.inOrgaoExtinto ? 'Sucede' : 'Centraliza'} : ${orgao.label}`;
      }
    }

    return (
      <DataGrid title="Destinação" icon="ico-route" >
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={this.verificaCampoBloqueado()}
              label="Tipo de Regime de Origem"
              number
              touched={this.props.touched}
              onChange={e => this.handleChange(e, 'tipoRegime')}
              placeholder="Selecione o tipo de regime origem"
              value={this.state.tipoRegime}
              itemList={listaTipoRegimes}
              required
              custom
            />
          </Grid>
        </div>
        { selecaoDestinacao }
        <div className="row">
          <Grid cols="12 12 12 12" style={{ color: '#27AE60' }}>
            { labelAviso }
          </Grid>
        </div>
      </DataGrid>
    );
  }
}

SelecaoDestinatario.propTypes = {
  acao: PropTypes.string.isRequired,
  // destinatario: PropTypes.number,
  destinatarios: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  apagaRegraDeCalculo: PropTypes.func.isRequired,
  touched: PropTypes.bool.isRequired,
  isRgpsSelecionando: PropTypes.bool.isRequired,
  calcularTempoRO: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ destinatarios: state.base.destinatarios });

export default connect(mapStateToProps)(SelecaoDestinatario);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/SelecaoDestinatario.jsx